import { cn } from 'shared/src/utils';
import React from 'react';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'> & { onValueChange?: (value: string) => void }>(
  ({ className, onChange, onValueChange, style, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[60px] w-full rounded border border-input bg-transparent px-3 py-2 text-base placeholder:text-muted-foreground focus-visible:ring-1 focus-visible:ring-enhancetitle disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className,
        )}
        style={{ outline: 'none', ...style }}
        onChange={(event) => {
          if (onChange) onChange(event);
          if (onValueChange) onValueChange(event.target.value);
        }}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
